import { AddressDetails } from "../smart-components/smart-component-property";
import { SmartComponentPropertyDetails } from "../smart-components/smart-component-property-details";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";

export class ComponentAdapterWeatherStation extends ComponentAdapterParent implements IComponentLoader {
    private _sunsetTime: AddressDetails = null;
    private _sunriseTime: AddressDetails = null;
    private _isDayNight: AddressDetails = null;
    private _isDayValue: string = "";
    private _windSpeed: AddressDetails = null;
    private _windAlarm: AddressDetails = null;
    private _rainAlarm: AddressDetails = null;
    private _actualTemperature: AddressDetails = null;
    private _ambientBrightness: AddressDetails = null;

    constructor() {
        super();
    }

    /**
     * Get sunset time address
     */
    get SunsetTime(): AddressDetails {
        return this._sunsetTime;
    }

    /**
      * Get sunrise time address
      */
    get SunriseTime(): AddressDetails {
        return this._sunriseTime;
    }

    /**
      * Get isDayNight address
      */
    get IsDayNight(): AddressDetails {
        return this._isDayNight;
    }

    /**
      * Get is day value
      */
    get IsDayValue(): string {
        return this._isDayValue;
    }

    /**
      * Get wind speed address
      */
    get WindSpeed(): AddressDetails {
        return this._windSpeed;
    }

    /**
    * Get wind alarm address
    */
    get WindAlarm(): AddressDetails {
        return this._windAlarm;
    }

    /**
    * Get rain alarm address
    */
    get RainAlarm(): AddressDetails {
        return this._rainAlarm;
    }

    /**
    * Get actual temperature address
    */
    get ActualTemperature(): AddressDetails {
        return this._actualTemperature;
    }

    /**
    * Get ambient brightness address
    */
    get AmbientBrightness(): AddressDetails {
        return this._ambientBrightness;
    }


    public fillProperty(listSmartComponentSkills: Array<SmartComponentPropertyDetails>): void {
        this._name = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.WEATHER_STATION_NAME)?.value || "";
        this._description = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.WEATHER_STATION_DESCRIPTION)?.value || "";

        this._sunriseTime = listSmartComponentSkills.find((titleSkill) => titleSkill.titleSkill === SkillNameList.WEATHER_STATION_SUNRISE_TIME)?.address || null;
        this._sunsetTime = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.WEATHER_STATION_SUNSET_TIME)?.address || null;
        this._isDayNight = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.WEATHER_STATION_IS_DAY_NIGHT)?.address || null;
        this._isDayValue = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.WEATHER_STATION_IS_DAY_VALUE)?.value || "";
        this._windSpeed = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.WEATHER_STATION_WIND_SPEED)?.address || null;
        this._windAlarm = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.WEATHER_STATION_WIND_ALARM)?.address || null;
        this._rainAlarm = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.WEATHER_STATION_RAIN_ALARM)?.address || null;
        this._actualTemperature = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.WEATHER_STATION_ACTUAL_TEMPERATURE)?.address || null;
        this._ambientBrightness = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.WEATHER_STATION_AMBIENT_BRIGHTNESS)?.address || null;

        this.fillMissingProperty();
        this.fillAddressState();
    }

    public fillMissingProperty(): void { }

    public fillAddressState(): void {
        if (this._sunriseTime) {
            this._listSubscribeAddress.push(this._sunriseTime);
        }

        if (this._sunsetTime) {
            this._listSubscribeAddress.push(this._sunsetTime);
        }

        if (this._isDayNight) {
            this._listSubscribeAddress.push(this._isDayNight);
        }

        if (this._windSpeed) {
            this._listSubscribeAddress.push(this._windSpeed);
        }

        if (this._windAlarm) {
            this._listSubscribeAddress.push(this._windAlarm);
        }

        if (this._rainAlarm) {
            this._listSubscribeAddress.push(this._rainAlarm);
        }

        if (this._actualTemperature) {
            this._listSubscribeAddress.push(this._actualTemperature);
        }

        if (this._ambientBrightness) {
            this._listSubscribeAddress.push(this._ambientBrightness);
        }
    }
}